/**
 * Format all services attached to an appointment as a single human-readable
 * string. Falls back to the legacy top-level `service_name` when the modern
 * `services` array is absent (older appointments).
 *
 * Examples:
 *   [{name:"Corte",qty:1}]                       → "Corte"
 *   [{name:"Corte",qty:2},{name:"Barba",qty:1}]  → "Corte (2×), Barba"
 */
export function formatAppointmentServices(a) {
  const list = Array.isArray(a?.services) ? a.services : [];
  if (list.length > 0) {
    return list
      .map((l) => {
        const name = l.service_name || l.name || "Serviço";
        const qty = Number(l.quantity || 1);
        return qty > 1 ? `${name} (${qty}×)` : name;
      })
      .join(", ");
  }
  return a?.service_name || "—";
}
